import React, { Component } from 'react';
//Checked
export default class view extends Component {
	constructor(props) {
		super(props);
		this.state = {
			moreInfo: null
		};
	}

	render() {
		return (
			<div style={{ textAlign: 'left', overflowWrap: 'break-word' }}>
				<p>Would you like information on formulas provided by WIC?</p>
				<div className="toggle">
					<div className={this.state.moreInfo === true ? 'Selected' : 'NotSelected'} onClick={(e) => { this.setState({ moreInfo: true }) }}>Yes</div>
					<div className={this.state.moreInfo === false ? 'Selected' : 'NotSelected'} onClick={(e) => { this.setState({ moreInfo: false }) }}>No</div>
				</div>
				<br />

				{this.state.moreInfo ? <div>	<br />
					<p>Growing Up Healthy hotline is available at 800-522-5006, 24 hours a day, 7 days a week, or go to the DOH website and click on ‘Healthy Lifestyle, Prevention, Nutrition, WIC’ to find a list of your local agencies.</p>
				</div> : ''}

				<div className="button" onClick={() => this.props.navigate('R8')}>Continue</div>
			</div>
		);
	}
}